import React, { useState } from "react";
import '../Css/Sondage.css';
import '../Css/checkboxes.css'
import axios from "axios";
import { Navigate } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export default function Sondage() {
  const [errors, setErrors] = useState({});
  const [visible,setVisible] = useState(false);

  const [sondage, setSondage] = useState({
    nom:"",
    prenom:"",
    
  });

  const [dbData, setDbData] = useState({
    nom: "",
    prenom: "",
    cocktail: false,
    repas: false,
    brunch: false,
  })

  const[checkedCocktail, setCheckedCocktail] = useState(false);
  const[checkedRepas, setCheckedRepas] = useState(false);
  const[checkedBrunch, setCheckedBrunch] = useState(false);

  const handleClickCocktail = () => setCheckedCocktail(!checkedCocktail);
  const handleClickRepas = () => setCheckedRepas(!checkedRepas);
  const handleClickBrunch = () => setCheckedBrunch(!checkedBrunch);

  const handleChange = (e) =>{
    setSondage(prev=>({...prev, [e.target.name]: e.target.value }));
  }

  // Fonction envoyant les données au serveur Node
  const sendSondage = async e => {
    e.preventDefault();

    const newErrors = validateForm(sondage);
    setErrors(newErrors);

    dbData.nom = sondage.nom;
    dbData.prenom = sondage.prenom;
    dbData.cocktail = convertToBinary(checkedCocktail);
    dbData.repas = convertToBinary(checkedRepas);
    dbData.brunch = convertToBinary(checkedBrunch);


    if (Object.keys(newErrors).length === 0) 
    {
      try
      {
        await axios.post("https://mariage-bs.ch:4006/sendSondage",dbData);
        setSondage({
          nom:"",
          prenom:""
        })
        setCheckedBrunch(false);
        setCheckedCocktail(false);
        setCheckedRepas(false);
        setVisible(true);
      }
      catch(err)
      {
        console.log(err);
      }
    } 
    else 
    {
        console.log('Form submission failed due to validation errors.');
        // emailLabelStyle = {backgroundColor:"#ecaaaa"};      
        // emailOccurences > 0 ? erreurMail = "Cet email existe déjà" : erreurMail = "votre email n'est pas valide";
    }
 
  }

    // fonction vérifiant si il y a des erreur dans le formulaire
    const validateForm = (data) => {
      const errors = {};

      if (data.nom ==="" || data.nom === undefined) {
          errors.nom = 'Veuillez entrer votre nom';
      }

      if (data.prenom ==="" || data.prenom === undefined) {
        errors.prenom = 'Veuillez entrer votre prénom';
        }
      return errors;
  }; 
  
  const convertToBinary = (value) => {
    const result = value === true ? 1 : 0;
    return result
  }

  // The Html of the form  
  return (
    <div id="Sondage">
      <Dialog header="Vos données ont bien été transmises !" visible={visible} position={"top"} style={{ width: '50vw' }} 
      onHide={() => {if (!visible) return; setVisible(false); }}
       draggable={false} resizable={false}
       breakpoints={{ '960px': '75vw', '641px': '100vw' }}
       >
        </Dialog>
        <div className='sondage-container'>
          <div className="section-title">
            <div className="title">Sondage</div>
            <div className="swirls">
              <img className="swirls-img" alt="" src="./Images/Icons/swirl_left.png"></img>
              <img className="swirls-img" alt="" src="./Images/Icons/swirl.png"></img>
            </div>
          </div>
            <form className="sondage-form">
            <div className="sondage-consigne">À remplir pour chaque personne invitée, Prière de répondre avant le 1er juin. </div>
            <label className="lbl-sondage" >Nom</label>
            <input className="txt-sondage" type="text" name="nom" maxLength="100" value={sondage.nom} onChange={handleChange}/>
            {errors.nom && (
                        <p className="error-message">
                            {errors.nom}
                        </p>
                    )}
            <label className="lbl-sondage" >Prénom</label>
            <input className="txt-sondage" type="text" name="prenom" maxLength="100" value={sondage.prenom} onChange={handleChange}/>
            {errors.prenom && (
                        <p className="error-message">
                            {errors.prenom}
                        </p>
                    )}
            
              <div className="checklist-title">Indiquez votre présence au activités suivantes . . </div>
              <div className="checklist-container">  
                <div className="cocktail"><label className="lbl-check">Cocktail</label>
                  <input name="cocktail" type="checkbox" onChange={handleClickCocktail} checked={checkedCocktail} className="ui-checkbox"></input>
                </div>
                <div className="repas"><label className="lbl-check">Repas</label>
                  <input name='repas'type="checkbox" onChange={handleClickRepas} checked={checkedRepas}  className="ui-checkbox"></input>
                </div>
                <div className="brunch"><label className="lbl-check">Brunch</label>
                  <input name="brunch" type="checkbox" onChange={handleClickBrunch} checked={checkedBrunch}  className="ui-checkbox"></input>
                </div>
            </div>
            <input type="submit" className="custom-submit" onClick={sendSondage} value="Envoyer"></input>
            </form>
        </div>
    </div>
    
  );
}